module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="base-form">\n	<h1>Email has been sent to 2017 registered email address</h1>\n	<p>An email has been sent to the 2017 registered email address provided. Follow the steps in the email to create another 2017 password and complete the link with your new NRL Account.</p>\n	<div class="buttons-wrapper">\n		<button type="button" class="btn secondary-btn js-resend">Resend email</button>\n		<button type="submit" class="btn primary-btn js-login">Login</button>\n	</div>\n</form>';
}
return __p;
};
